import { ReadingStatus } from 'infrastructure/enums';
import { columnsWidth } from 'components/molecules/rpm-overview-table/constants';
import useUser from 'utils/useUser';
import classNames from 'classnames';
import { Flex } from 'antd';

import s from './styles.module.scss';
import ReadingsBlock from './block';

import type { FC } from 'react';

interface Props {
  critical: number;
  atRisk: number;
  normal: number;
  disableRiskAndNormal?: boolean;
}

const ReadingsColumn: FC<Props> = ({
  critical,
  atRisk,
  normal,
  disableRiskAndNormal,
}) => {
  const { isCriticalRole, isAtRiskRole } = useUser();

  let width = columnsWidth.readingType;
  if (isCriticalRole) {
    width = columnsWidth.readingType / 3;
  } else if (isAtRiskRole) {
    width = (columnsWidth.readingType / 3) * 2;
  }

  return (
    <Flex style={{ width }}>
      <Flex
        className={classNames(s.container, {
          [s['two-col']]: isAtRiskRole,
          [s['one-col']]: isCriticalRole,
        })}
      >
        {!isAtRiskRole && (
          <ReadingsBlock status={ReadingStatus.Critical} count={critical} />
        )}
        {!isCriticalRole && (
          <ReadingsBlock
            status={ReadingStatus.Risk}
            count={atRisk}
            disable={disableRiskAndNormal}
          />
        )}
        {!isCriticalRole && (
          <ReadingsBlock
            status={ReadingStatus.Normal}
            count={normal}
            disable={disableRiskAndNormal}
          />
        )}
      </Flex>
    </Flex>
  );
};

export default ReadingsColumn;
